<template>
  <div class="employeePage">
    <section class="main flex">
      <!-- 员工风采 -->
      <div class="tableft">
        <div class="pannel_box">
          <div class="pannel_top flex">
            <h2>招聘类型</h2>
            <span>JOB TYPE</span>
          </div>
          <ul class="e_type flex">
            <li v-for="(item,index) in tab" :key="index" @click="switchtab(item.value)" :class="{'act':item.flag}">{{item.name}}</li>
            <!-- <li></li> -->
          </ul>
        </div>
        <!-- <div class="pannel_box">
          <div class="pannel_top flex">
            <h2>招聘动态</h2>
            <span>NEWS</span>
            <div class="more">更多></div>
          </div>
          <ul class="flex act_type">
            <li class="nodata">暂无内容</li>
          </ul>
        </div>-->
      </div>
      <div class="develop">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">JOB SEARCH</div>
            <div class="title2">职位搜索</div>
          </div>
        </div>
        <div class="inpbox flex">
          <el-select
            v-model="form.province"
            clearable
            placeholder="请选择"
            class="select"
            @change="selectProvimce"
          >
            <el-option
              v-for="item in provincearr"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-select
            v-model="form.city"
            clearable
            placeholder="选择城市"
            class="select"
            @change="selectcity"
          >
            <el-option v-for="item in cityarr" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
          <div class="hline"></div>
        </div>
		
        <div class="storelist">
          <el-table :data="list" style="width: 100%" v-loading="loading">
            <el-table-column prop="position" label="职位名称" width="180"></el-table-column>
            <el-table-column prop="salary" label="薪资" width="180"></el-table-column>
            <el-table-column prop="location" label="工作地点"></el-table-column>
            <el-table-column prop label="操作" width="180">
              <template slot-scope="scope">
                <img src="../assets/img/tv/icon_edit.png" class="edit_icon" alt="">
                <el-button
                  type="text"
                  size="small"
                  class="btns"
                  @click="writeBook(scope.row.id,scope.row.recruitmentUrl)"
                >点击了解详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next,jumper" :total="total" v-show="total>0" @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </section>
	
    <el-dialog
      title="填写简历"
      :visible.sync="dialogFormVisible"
      width="652px"
      class="forms"
      :close-on-click-modal="false"
    >
      <el-form :model="editform" :rules="rules" ref="editform">
        <div class="flex form_item">
          <el-form-item label="姓名:" :label-width="formLabelWidth" prop="name">
            <el-input v-model="editform.name" autocomplete="off"></el-input>
          </el-form-item>
           <el-form-item label="学历:" :label-width="formLabelWidth" prop="education">
            <el-input v-model="editform.education" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div class="flex form_item">
           <el-form-item label="性别:" :label-width="formLabelWidth" prop="sex">
            <el-select v-model="editform.sex" placeholder="请选择性别">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
         
          <el-form-item label="电话:" :label-width="formLabelWidth" prop="phone">
            <el-input v-model="editform.phone" autocomplete="off"></el-input>
          </el-form-item>
        </div>

        <div class="flex form_item">
          <el-form-item label="年龄:" :label-width="formLabelWidth" prop="age">
            <el-input v-model="editform.age" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div class="dialog-footer">
          <el-button class="cancel" @click="resetForm('editform')">取 消</el-button>
          <el-button class="submit" @click="submitForm('editform')" :loading="sloading">提 交</el-button>
        </div>
      </el-form>
      
    </el-dialog>
  </div>
</template>

<script>
import { province } from "../utils/map.js";
import { recruitment,add } from "../api/index.js";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
          console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
    return {
      tab:[
        {
          name:'门店招聘',
          flag:true,
          value:1,
        },
        {
          name:'办公室招聘',
          flag:false,
          value:0,
        }
      ],
      provincearr: [],
      provinceValue: "",
      cityValue: "",
      cityarr: [],
      editform: {
        recruitmentId: "",
        name: "",
        sex: "",
        phone: "",
        age: "",
        education: "",
      },
      form:{
        province:'',
        city:'',
        type:'1',//0：办公室、1：门店
      },
      rules: {
          name: [
            { required: true, message: '请填写姓名', trigger: 'blur' },
          ],
          sex: [
            { required: true, message: '请选择性别', trigger: 'change' }
          ],
          phone: [
            {required: true,validator: checkPhone, trigger: 'blur'}
          ],
          age: [
            { required: true, message: '请填写年龄', trigger: 'blur' },
          ],
          education: [
             { required: true, message: '请填写学历', trigger: 'blur' },
          ],
        },
      formLabelWidth: "60px",
      dialogFormVisible: false,
      list: [],
      total: 0,
      loading:true,
      pageNum:1,
      sloading:false,
    };
  },
  created() {
    this.provincearr = province;
    this.getList();
  },
  methods: {
    switchtab(val){
      this.tab.forEach(v=>{
        if(val==v.value){
          v.flag=true;
        }else{
          v.flag=false;
        }
      })
      for(let i in this.form){
        console.log(i)
        this.form[i]=''
      }
      this.pageNum=1;
      this.form.type=val;
      this.getList()
    },
     submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.editform)
            this.sloading=true;
            add(this.editform).then(res=>{
              console.log(res)
              if(res.resultCode=='0'){
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
              }
              this.dialogFormVisible=false;
              this.sloading=false;
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    resetForm(formName) {
      this.dialogFormVisible=false;
        this.$refs[formName].resetFields();
      },
    selectProvimce(id) {
      this.cityarr = [];
      this.form.city = "";
      for (let item of this.provincearr) {
        if (id == item.name) {
          console.log(item);
          this.cityarr = item.children;
        }
      }
    },
    selectcity(id) {
      this.pageNum=1;
      this.getList()
    },
    getList() {
      this.loading=true;
      let param = {
        pageNum: this.pageNum,
        pageSize: 10,
        type:this.form.type,
        province:this.form.province,
        city:this.form.city,
      };
      recruitment(param).then(res => {
        console.log(res);
        if (res.resultCode == "0") {
          this.list = res.data.list;
          this.total = res.data.total;
        }
        this.loading = false;
      });
    },
    writeBook(id,url) {
      console.log(id);
      if(this.form.type=='0'){
        window.open(url,'_blank')
      }else{
        this.editform.recruitmentId=id;
      this.dialogFormVisible = true;
      }
      
    },
    handleCurrentChange(val) {
      console.log(val)
      this.pageNum=val;
      for(let i in this.form){
        console.log(i)
        this.form[i]=''
      }
      // console.log(this.form)
      this.getList()
      // 当前页 改变
    }
  }
};
</script>

<style lang="scss" scoped>
.employeePage {
  text-align: left;
  background: #fafafa;
  .main {
    width: 1200px;
    margin: 0 auto;
  }
  .edit_icon{
    margin-right: 6px;
  }
  .tableft {
    width: 240px;
    margin: 20px 20px 0 0;
    .pannel_box {
      background: #fff;
      border-radius: 4px;
      padding: 0 20px;
      margin-bottom: 20px;
    }
    .pannel_top {
      padding: 20px 0 12px;
      border-bottom: 1px solid #e6e6e6;
      align-items: center;
      h2 {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        margin-right: 8px;
      }
      span {
        flex: 1;
        opacity: 0.4;
        font-family: ApercuPro-Medium;
        font-size: 14px;
        color: #7a7a7a;
      }
      .more {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #7a7a7a;
        text-align: right;
      }
    }
    .e_type {
      padding: 32px 0 36px;
      justify-content: space-between;
      li {
        width: 90px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        cursor: pointer;
      }
      .act {
        background: #ffe800;
        font-weight: 600;
        color: #4c0104;
      }
    }
    .act_type {
      padding: 32px 0 36px;
    }
    .nodata {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
    }
  }
  .develop {
    width: 940px;
    border-radius: 4px;
    background: #fff;
    margin: 20px auto;
    padding: 0 32px 86px;
    .top_title {
      position: relative;
      text-align: center;
      margin-bottom: 53px;
    }

    .top_title .title1 {
      position: absolute;
      top: 30px;
      left: 0;
      width: 100%;
      font-family: jx;
      font-size: 60px;
      color: rgba(76, 1, 4, 0.05);
      line-height: 60px;
      text-align: center;
      font-weight: 400;
      margin-bottom: 6px;
    }

    .top_title .title2 {
      font-family: jx;
      font-size: 40px;
      color: #4c0104;
      text-align: center;
      font-weight: 500;
      width: 100%;
      margin-bottom: 32px;
      padding-top: 32px;
      position: relative;
      z-index: 1;
    }
    .inpbox {
      align-items: center;
      margin-bottom: 23px;
      .hline {
        flex: 1;
        height: 2px;
        background: #ffe800;
      }
    }
    .select {
      width: 200px;
      margin-right: 43px;
    }
    .storelist {
      width: 876px;
      margin: 0 auto;
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      tr {
        td {
          &:nth-child(1) {
            color: #7a7a7a;
          }
        }
      }
    }
  }
  .dialog-footer{
    text-align: right;
    margin:0px 0 28px;
  }
}
</style>
<style lang="scss">
.employeePage .storelist {
  width: 876px;
  margin: 0 auto;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  .el-table::before {
    height: 0;
  }
  tr {
    th {
      &:nth-child(1) {
        > div {
          padding: 0 0 0 50px;
        }
      }
      > div {
        color: #333333;
      }
    }
    td {
      border: none;
      padding: 0 0 20px;

      &:nth-child(1) {
        color: #333333;
        padding: 0 0 20px 40px;
      }
      &:nth-child(2) {
        color: #ffb100;
      }
    }
    .btns {
      color: #ffb100;
    }
  }

  /* 移除table组件hover背景色 */
  .el-table__row:hover > td {
    background: #fff !important;
  }
  .el-table th.is-leaf {
    border: none;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #4c0104;
    color: #ffe900;
  }
  .el-pagination {
    margin: 0 0 37px 40px;
  }
}
.employeePage .forms {
  .el-dialog {
    border-radius: 10px;
    padding: 0 24px;
  }
  .el-dialog__title {
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    font-weight: 600;
  }
  .form_item {
    justify-content: space-between;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  input,
  select {
    width: 240px;
    height: 34px;
    line-height: 34px;
  }
  .el-form-item__label {
    color: rgba(0, 0, 0, 0.85);
  }
  .el-dialog__header {
    padding: 18px 10px;
    border-bottom: 1px solid #e6e6e6;
  }
  .el-dialog__body {
    padding: 30px 0 6px;
  }
  .cancel,
  .submit {
    width: 72px;
    height: 34px;
    line-height: 34px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    background: #fff;
    cursor: pointer;
    padding:0;
  }
  .cancel {
    margin-right: 16px;
  }
  .submit {
    background: #ffe800;
    border: 1px solid #ffe800;
  }
}
</style>